import React from "react";
import { renderRichText } from "gatsby-source-storyblok";

const CorpSupportSection = ({blok}) => {

  return (
    <section className="flex flex-wrap">

      <div className="w-full lg:w-1/2 p-10 lg:p-24 flex justify-start lg:justify-end items-center">
        <div className="max-w-[800px]">        
          <h2 className="text-3xl font-bold mb-8">{blok.title}</h2>
          <div className="text-ml leading-relaxed" dangerouslySetInnerHTML={{__html: renderRichText(blok.description)}} />
        </div>
      </div>

      <div className="w-full lg:w-1/2 p-10 lg:p-24 flex justify-start items-center bg-[#FCFBF8]">
        <div className="max-w-[650px]">
          {blok.supportItems.map((item) =>(
            <div className="flex" key={item._uid}>
              <div className="flex-shrink-0">
                <img className="w-[45px] h-[45px]" loading="lazy" src={item.icon.filename} alt={item.icon.alt}/>
              </div>
              <div className="px-6 mb-8">
                <div className="text-xs font-serif">{item.subTitle}</div>
                <h3 className="text-xl font-bold">{item.title}</h3>
                <div className="text-md leading-relaxed" dangerouslySetInnerHTML={{__html: renderRichText(item.detail)}} />
              </div>
            </div>
          ))}
        </div>
      </div>

    </section>
  );
};
  
export default CorpSupportSection
